import { render } from "./CadastroPessoaAntt.vue?vue&type=template&id=3876c75e&scoped=true"
import script from "./CadastroPessoaAntt.vue?vue&type=script&lang=ts"
export * from "./CadastroPessoaAntt.vue?vue&type=script&lang=ts"

import "./CadastroPessoaAntt.vue?vue&type=style&index=0&id=3876c75e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3876c75e"

export default script